function splider() {
    const collectionIconSlide = document.querySelector('.collection-icon-slide');
    if (collectionIconSlide) {
        const collectionIconSlider = new Splide(collectionIconSlide, {
            perPage: 9,
            perMove: 1,
            gap: 16,
            pagination: false,
            arrows: false,
            autoplay: true,
            breakpoints: {
            1024: {
                perPage: 7,
                arrows: true,
            },
            820: {
                perPage: 5,
            }, 
            767: {
                perPage: 3,
                gap: 10,
            },
            375: {
                perPage: 2,
            },
            }
        });
        collectionIconSlider.mount();
    }
}
splider();